import { Typography } from '@mui/material';

import { styled } from '@mui/material/styles';
import { Product, SubscriberProductResponseDto } from '@subflow/api-client';

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.up(1368)]: {
    padding: theme.spacing(5, 8),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 0),
  },
}));

type Props = {
  product: Product | SubscriberProductResponseDto;
};

export default function SubscriptionSimpleSummary({ product }: Props) {
  return (
    <RootStyle>
      <div>
        <Typography data-testid="subscription-simple-summary-name" variant="h4">
          {product.name}
        </Typography>
      </div>
      <Typography
        data-testid="subscription-simple-summary-description"
        sx={{ whiteSpace: 'pre-wrap' }}
      >
        {product.description}
      </Typography>
    </RootStyle>
  );
}
